<template>
  <el-table :data="tableData" class="loan-base-info" border highlight-current-row style="width: 100%"
    @row-click="handleCurrentLoanItem">
    <el-table-column prop="id" label="合同编号" width="70" />
    <el-table-column prop="taskStatus" label="案件状态" />
    <el-table-column prop="loanProduct" label="业务类型" />
    <el-table-column prop="realLoanTime" label="产品" width="150" />
    <el-table-column prop="realLoanTime" label="进件渠道" width="150" />
    <el-table-column prop="realLoanTime" label="资方" width="150" />
    <el-table-column prop="realLoanTime" label="放款时间" width="150" />
    <el-table-column prop="orderAmount" label="合同金额" />
    <el-table-column label="应还未还款" width="150">
      <template slot-scope="scope">
        {{ scope.row.totalRepayAmount }}
      </template>
    </el-table-column>
    <el-table-column label="入催时间" width="150">

      <template slot-scope="scope">
        {{ scope.row.createdTaskTime }}
      </template>
    </el-table-column>
    <el-table-column prop="totalInterest" label="逾期天数" />
    <el-table-column prop="totalFee" label="逾期本金" />
    <el-table-column prop="overdueManageFee" label="逾期利息" />
    <el-table-column prop="repayDelayAmount" label="逾期服务费" width="150" />
    <el-table-column prop="penaltyDay" label="罚息" />
    <el-table-column prop="penaltyDay" label="违约金" />
    <el-table-column prop="penaltyDay" label="滞纳金" />
    <el-table-column prop="penaltyDay" label="逾期金额" />
    <el-table-column label="操作">

      <template slot-scope="scope">
        <el-button v-if="!scope.row.id" @click="changeTable">
          {{ tableData.length > 1 ? '收起' : '展开' }}
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Lib from './lib.js'
export default {
  name: 'item-task-info',
  props: {
    taskId: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      sunList: [],
      tableData: []
    }
  },
  computed: {
    ...mapGetters([
      'currentLoanItem',
      'loanItemInfoList',
      'totalRepayAmount'
    ])
  },
  created() {
    this.fetchLoanItemInfo({ taskId: this.taskId }).then(res => {
      const ops = { ...res[0] }
      ops.loanProduct = '现金分期'
      ops.totalPrincipal = 0
      ops.totalInterest = 0
      ops.totalFee = 0
      ops.overdueManageFee = 0
      ops.totalRepayAmount = 0
      ops.orderAmount = 0
      ops.repayDelayAmount = 0
      ops.id = null
      res.forEach((item) => {
        ops.orderAmount = Lib.accAdd(ops.orderAmount, Number(item.orderAmount))
        ops.totalPrincipal = Lib.accAdd(ops.totalPrincipal, Number(item.totalPrincipal))
        ops.totalInterest = Lib.accAdd(ops.totalInterest, Number(item.totalInterest))
        ops.totalFee = Lib.accAdd(ops.totalFee, Number(item.totalFee))
        ops.overdueManageFee = Lib.accAdd(ops.overdueManageFee, Number(item.overdueManageFee))
        ops.repayDelayAmount = Lib.accAdd(ops.repayDelayAmount, Number(item.repayDelayAmount))
        ops.totalRepayAmount = Lib.accAdd(ops.totalRepayAmount, Number(item.totalRepayAmount))
      })
      this.$store.commit('TOTAL_REPAY_AMOUNT', ops.totalRepayAmount)
      this.sunList.push(ops)
      this.tableData.push(ops)
    })
  },
  methods: {
    ...mapActions([
      'fetchLoanItemInfo',
      'setCurrentLoanItem'
    ]),
    handleCurrentLoanItem(row, event, column) {
      this.setCurrentLoanItem({ loanItem: row })
    },
    changeTable() {
      const length = this.tableData.length
      if (length > 1) {
        this.tableData.splice(1, length)
      } else {
        this.tableData = this.tableData.concat(this.loanItemInfoList)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.loan-base-info {
  margin-bottom: 15px;
}
</style>
